import Form from "./Form";
import { Container } from "./Container/styled";
import Clock from "./Clock";

function App() {
  return (
    <Container>
      <Clock />
      <Form />
    </Container>
  );
}

export default App;
